import { render } from "./FeedHead.vue?vue&type=template&id=115f35c4"
import script from "./FeedHead.vue?vue&type=script&lang=js"
export * from "./FeedHead.vue?vue&type=script&lang=js"

import "./FeedHead.vue?vue&type=style&index=0&id=115f35c4&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__